import React, { useEffect } from 'react'
import { COMMON_FILTERS_COMPONENTS, BACKEND_APIS } from '@constants'
import { offices, officesPickoff, rentalDates, sites, rentalLength, showDropoffOffice } from '@signals'
import { areCommonFiltersValid } from '@signals/commonFilters/filters'
import { removeDuplicatedDates } from '@utils'
import { dateToString } from 'Pages/ReportsAlerts/Reports/@utils'
import RealTimeFiltersFooterActions from './Footer'
import { AppCommonFilters } from '@components'
import { useValidatorSeeker } from '@app'
import { isSearching } from 'Pages/RealTimeHistory/RealTime/@signals'
import { useRealTimeFilters } from 'Pages/RealTimeHistory/RealTime/@hooks'
import { realTimeSchema } from 'Pages/RealTimeHistory/RealTime/schema'
import {disabledBeforeToday} from "@ui-seeker/core";


export default function RealTimeFilters() {

	const { isValid, errors } = useValidatorSeeker({
		officePickupID: offices.value,
		officePickoffID: officesPickoff.value,
		siteID: sites.value,
		rentalLength: rentalLength.value,
		rentalDates: rentalDates.value,
	}, realTimeSchema)

	useRealTimeFilters()

	useEffect(() => {
		areCommonFiltersValid.value = isValid
	}, [JSON.stringify(errors)])

	return <AppCommonFilters
		headerComponents={[{ name: COMMON_FILTERS_COMPONENTS.SHOW_DROPOFF }]}
		components={[
			{
				name: COMMON_FILTERS_COMPONENTS.OFFICE_PICKUP,
				multiple: false,
				realtime: 'true',
				disabled: isSearching.value,
				error: errors?.officePickupID,
				grid: { xs: showDropoffOffice.value ? 4 : 5 }
			},showDropoffOffice.value && {
				name: COMMON_FILTERS_COMPONENTS.OFFICE_DROPOFF,
				multiple: false,
				disabled: isSearching.value,
				error: errors?.officePickoffID,
			}, {
				name: COMMON_FILTERS_COMPONENTS.SITE,
				urlAjax: `${BACKEND_APIS.MASTER_DATA}/options/site`,
				disabled: isSearching.value,
				error: errors?.siteID,
				grid: { xs: showDropoffOffice.value ? 4 : 5 }
			}, {
				name: COMMON_FILTERS_COMPONENTS.START_HOUR,
				disabled: isSearching.value,
				grid: { xs: 1 },
			}, {
				name: COMMON_FILTERS_COMPONENTS.END_HOUR,
				disabled: isSearching.value,
				grid: { xs: 1 },
			}, {
				name: COMMON_FILTERS_COMPONENTS.RENTAL_DATES,
				error: errors?.rentalDates,
				disabled: isSearching.value,
				shouldDisableDate: disabledBeforeToday(),
				onChange: date => {
					rentalDates.value = removeDuplicatedDates(dateToString(date))
				},
				grid: { xs: showDropoffOffice.value ? 4 : 5 }

			}, {
				name: COMMON_FILTERS_COMPONENTS.RENTAL_LENGTH_TAGS,
				disabled: isSearching.value,
				error: errors?.rentalLength,
				grid: { xs: showDropoffOffice.value ? 4 : 5 }

			}, {
				name: COMMON_FILTERS_COMPONENTS.CURRENCY,
				urlAjax: `${BACKEND_APIS.MASTER_DATA}/all/options/currencies`,
				disabled: isSearching.value,
				grid: { xs: 2 },
			},
		]}
		Footer={RealTimeFiltersFooterActions}
	/>
}